module.exports = __webpack_public_path__ + "img/image125.bb2184bf.png";